import React from "react";
import { Edit, TextInput, SimpleForm } from "react-admin";

const today = new Date();

export const CultureMediaEdit = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm defaultValue={{ updated_at: today }}>
        <TextInput source="code" />
        <TextInput source="culture_medium" />
      </SimpleForm>
    </Edit>
  );
};
